import { useParams } from "react-router-dom";
import { useGetDialogQuery } from "../../dialogs/dialogsSlice";
import { useSelector } from "react-redux";
import { selectIsRightPanelExpanded } from "../../../app/rightPanelSlice";

const useCanvasContainer = () => {
  const { dialogId } = useParams();
  const panelExpanded = useSelector(selectIsRightPanelExpanded);

  const currentDialog = useGetDialogQuery(
    { dialogId },
    { skip: dialogId == null || dialogId === "new" }
  );

  const canvas = currentDialog?.data?.canvas;

  return {
    canvasObjects: canvas?.objects || [],
    hash: canvas?.hash,
    isLoading: currentDialog?.isLoading,
    panelExpanded,
  };
};

export default useCanvasContainer;
